module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/job-posts/job-posts.component.css
// module id = ./src/app/components/job-posts/job-posts.component.css
// module chunks = main